export enum ZoomModeType {
  In,
  Out,
}
